import types from "../types";
import { copy, Notification } from "../../utils";
import backend from "../../api";
import {
  global_actions,
  cart_actions,
  wishlist_actions,
  order_actions,
  adcard_actions,
  product_actions,
} from "../";
import { setDefaultPayment } from "../paymentMethod/action";

const register = (user,history) => (dispatch, getState) => {
  const state = copy(getState().auth);
  const status = new Notification();
  dispatch(global_actions.loading(true));
  backend
    .post(`/user/create/${user.role}`, user)
    .then(({ data: { data } }) => {
      state.user = data;
      // history.push("/payment-integration");
      status.set_toast("success", data.message);
      sessionStorage.setItem("token", data.token);
      if (user.role === "customer") {
        dispatch({
          type: types.CART,
          payload: data.cart,
        });
        dispatch({
          type: types.WISHLIST,
          payload: data.favorite,
        });
        // dispatch(order_actions.fetch_orders({ customer: state.user._id }));
      } else if (user.role === "member") {
        dispatch(
          // adcard_actions.fetch_adcard({ member_user: data.data.user._id })
          adcard_actions.fetch_adcard({ member_user: data.user._id })
        );
      }
      if(history){
        history.push("/onboard-account");
      }
    })
    .catch((error) => {
      status.set_toast(
        "error",
        error.response ? error.response.data.message : error.message
      );
    })
    .finally(() => {
      dispatch({
        type: types.AUTH,
        payload: state,
      });
      status.show_toast();
      if (state.user && state.user.role === "customer") {
        let cart_local = localStorage.getItem("cart");
        let wishlist_local = localStorage.getItem("wishlist");
        if (cart_local && JSON.parse(cart_local).items.length > 0) {
          JSON.parse(cart_local).items.forEach((cl) => {
            dispatch(
              cart_actions.add_to_cart({
                product: cl.product,
                quantity: cl.quantity,
                member_user: cl.member_user ? cl.member_user : undefined,
              })
            );
          });
          localStorage.removeItem("cart");
        }
        if (wishlist_local && JSON.parse(wishlist_local).items.length > 0) {
          JSON.parse(wishlist_local).items.forEach((wl) => {
            dispatch(
              wishlist_actions.add_to_wishlist({
                product: wl.product,
                quantity: wl.quantity,
                member_user: wl.member_user ? wl.member_user : undefined,
              })
            );
          });
          localStorage.removeItem("wishlist");
        } else {
          dispatch(global_actions.loading(false));
        }
      } else {
        dispatch(global_actions.loading(false));
      }
    });
};

const login = (user, history) => (dispatch, getState) => {
  const state = copy(getState().auth);
  const status = new Notification();
  dispatch(global_actions.loading(true));

  backend
    .post(`/user/login`, { email: user.email, password: user.password })
    .then(({ data }) => {
      console.log("data", data);
      if (
        data.data.user.role === "merchant" &&
        !data.data.participating_merchant
      ) {
        status.set_toast(
          "error",
          "Merchant is not participating in the program. Cannot log in."
        );
        status.show_toast();
        dispatch(global_actions.loading(false));
        return;
      }

      state.user = data.data;
      status.set_toast("success", data.message);
      sessionStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.data));
      if (user.remember) {
        localStorage.setItem("token", data.token);
      }

      if (data.data.user.role !== "customer") {
        backend
          .get("/accounts", {
            params: { userId: data?.data?.user?._id, isDefault: true },
          })
          .then((res) => {
            const accountId = res?.data?.accounts?.[0]?.accountId;
            if (accountId) {
              dispatch(setDefaultPayment(accountId));
            }
          });
      }

      if (data.data.user.role === "customer") {
        dispatch({
          type: types.CART,
          payload: data.cart,
        });
        dispatch({
          type: types.WISHLIST,
          payload: data.favorite,
        });
      } else if (data.data.user.role === "member") {
        dispatch(
          adcard_actions.fetch_adcard({ member_user: data.data.user._id })
        );
      } else if (
        data.data.user.role === "star" ||
        data.data.user.role === "admin" ||
        data.data.user.role === "gamer"
      ) {
        status.set_toast("warn", "Admin, Gamer, and Star can't login here");
        state.user = null;
        localStorage.removeItem("token");
        sessionStorage.removeItem("token");
      }

      if(history) history()
    })
    .catch((error) => {
      status.set_toast(
        "error",
        error.response ? error.response.data.message : error.message
      );
      status.show_toast();
    })
    .finally(() => {
      dispatch({
        type: types.AUTH,
        payload: state,
      });
      dispatch(global_actions.loading(false));
    });
};

const login_by_token = () => (dispatch, getState) => {
  const state = copy(getState().auth);
  const status = new Notification();
  dispatch(global_actions.loading(true));
  backend
    .get(`/user/my`)
    .then(({ data }) => {
      state.user = data.data;
      sessionStorage.setItem("token", data.token);
      if (data.data.user.role === "customer") {
        dispatch({
          type: types.CART,
          payload: data.cart,
        });
        dispatch({
          type: types.WISHLIST,
          payload: data.favorite,
        });
        // dispatch(order_actions.fetch_orders({ customer: state.user._id }));
      } else if (data.data.user.role === "member") {
        dispatch(
          adcard_actions.fetch_adcard({ member_user: data.data.user._id })
        );
      }
      // else if (data.data.user.role === "merchant") {
      //   dispatch(
      //     product_actions.fetch_products({
      //       merchant_user: data.data.user._id,
      //       published: true,
      //     })
      //   );
      // }
    })
    .catch((error) => {
      status.set_toast(
        "error",
        error.response ? error.response.data.message : error.message
      );
    })
    .finally(() => {
      dispatch({
        type: types.AUTH,
        payload: state,
      });
      dispatch(global_actions.loading(false));
      status.show_toast();
    });
};

const update_password = (change) => (dispatch, getState) => {
  const state = copy(getState().auth);
  const status = new Notification();
  dispatch(global_actions.loading(true));
  if (state) {
    backend
      .put(`/user/${state.user.user._id}/password/change`, change)
      .then(({ data }) => {
        sessionStorage.setItem("token", data.token);
        if (localStorage.getItem("token")) {
          localStorage.setItem("token", data.token);
        }
        status.set_toast("success", data.message);
      })
      .catch((error) => {
        status.set_toast(
          "error",
          error.response ? error.response.data.message : error.message
        );
      })
      .finally(() => {
        dispatch({
          type: types.AUTH,
          payload: state,
        });
        dispatch(global_actions.loading(false));
        status.show_toast();
      });
  } else {
    status.set_toast("warn", "Please Login First");
    status.show_toast();
  }
};

// const update_customer = (update) => (dispatch, getState) => {
//   const state = copy(getState().auth)
//   const status = new Notification()
//   dispatch(global_actions.loading(true))
//   backend
//     .put(`/customer/${state.user._id}`, update)
//     .then(({ data }) => {
//       state.user = data.data
//     })
//     .catch((error) => {
//       status.set_toast(
//         'error',
//         error.response ? error.response.data.message : error.message
//       )
//     })
//     .finally(() => {
//       dispatch({
//         type: types.AUTH,
//         payload: state,
//       })
//       dispatch(global_actions.loading(false))
//       status.show_toast()
//     })
// }

const logout = () => async (dispatch) => {
  localStorage.removeItem("token");
  sessionStorage.removeItem("token");
  await dispatch({
    type: types.AUTH_RESET,
  });
};

const updateCustomer = (update) => (dispatch, getState) => {
  const state = copy(getState().auth);
  let {
    customerId,
    first_name,
    last_name,
    middle_name,
    userId,
    phone,
    ...data
  } = update;
  const userData = { first_name, last_name, middle_name, phone };
  const status = new Notification();
  dispatch(global_actions.loading(true));

  backend
    .put(`/user/${userId}`, userData)
    .then(({ data: { data, message } }) => {
      dispatch(login_by_token());
      // state.user = data.data
      status.set_toast("success", message);
    })
    .catch((error) => {
      status.set_toast(
        "error",
        error.response ? error.response.data.message : error.message
      );
    });
  backend
    .put(`/customer/${customerId}`, data)
    .then(({ data }) => {
      // state.user = data.data
    })
    .catch((error) => {
      status.set_toast(
        "error",
        error.response ? error.response.data.message : error.message
      );
    })
    .finally(() => {
      dispatch({
        type: types.AUTH,
        payload: state,
      });

      dispatch(global_actions.loading(false));
      status.show_toast();
    });
};

const updateCredentials = (update) => (dispatch, getState) => {
  const state = copy(getState().auth);
  let { id, ...data } = update;

  // console.log(update)
  const status = new Notification();
  dispatch(global_actions.loading(true));
  backend
    .put(`/user/${id}`, update)
    .then(({ data }) => {
      dispatch(login_by_token());
      // state.user = data.data

      status.set_toast("success", data.message);
    })
    .catch((error) => {
      status.set_toast(
        "error",
        error.response ? error.response.data.message : error.message
      );
    })
    .finally(() => {
      dispatch({
        type: types.AUTH,
        payload: state,
      });
      dispatch(global_actions.loading(false));
      status.show_toast();
    });
};

const updateCredentialsByRole = (update, role) => (dispatch, getState) => {
  const state = copy(getState().auth);
  let { id, ...data } = update;

  // console.log(update)
  const status = new Notification();
  dispatch(global_actions.loading(true));
  backend
    .put(`/user/${role}/${id}`, update)
    .then(({ data }) => {
      // state.user = data.data
      dispatch(login_by_token());
      status.set_toast("success", data.message);
    })
    .catch((error) => {
      status.set_toast(
        "error",
        error.response ? error.response.data.message : error.message
      );
    })
    .finally(() => {
      dispatch({
        type: types.AUTH,
        payload: state,
      });
      dispatch(global_actions.loading(false));
      status.show_toast();
    });
};

const reset_password = (change) => (dispatch) => {
  const status = new Notification();
  dispatch(global_actions.loading(true));

  backend
    .put(`/user/password/reset/${change.token}`, { password: change.password })
    .then(({ data }) => {
      status.set_toast("success", data.message);
    })
    .catch((error) => {
      status.set_toast(
        "error",
        error.response ? error.response.data.message : error.message
      );
    })
    .finally(() => {
      dispatch(global_actions.loading(false));
      status.show_toast();
    });
};

export default {
  register,
  login,
  login_by_token,
  logout,
  reset_password,
  // update_customer,
  update_password,
  updateCredentials,
  updateCredentialsByRole,

  updateCustomer,
};
